import Typography from "@portal/components/atoms/v2/typography";
import { CustomFund } from "../helpers/MapFundsToList";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { LoadingFunds } from "./LoadingFunds";
import { GlobeComponent } from "@portal/components/atoms/globe/GlobeComponent";
import Icon from "@portal/components/atoms/icons";
import Link from "next/link";
import { morningstarKeyInfoLink } from "@portal/helpers/morningstarKeyInfoLink";
import { GetFundColorClass } from "../helpers/GetFundColor";

interface Props {
  isDefaultLanguage: boolean;
  funds: CustomFund[];
  isLoading: boolean;
}

const ignoreFund = (fund: CustomFund) => {
  return fund.isin === "NOXXXXXXCASH" || fund.isin === "IE00BMWPZH81" || fund.isin === "IE0009MTA5P0";
};

export const SavingSuggestionFunds = ({ isDefaultLanguage, funds, isLoading }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col mb-2 border dark:border-blueBorderDark rounded-lg bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark p-2">
      <div className="grid grid-cols-robot-funds md:grid-cols-robot-funds-md">
        <div className="mr-2">
          <Typography className="truncate" variant="DescriptionBold">
            {texts.PAGE_14_COLUMN_HEADER}
          </Typography>
        </div>
        <div>
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_A}</Typography>
        </div>
        <div className="hidden justify-end md:flex">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_B}</Typography>
        </div>
        <div className="hidden justify-end md:flex">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_C}</Typography>
        </div>
        <div className="flex justify-end">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_D}</Typography>
        </div>
        <div className="flex justify-end">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_E}</Typography>
        </div>
      </div>
      {isLoading && <LoadingFunds />}

      {!isLoading &&
        funds.map(fund => {
          return (
            <div
              className="grid grid-cols-robot-funds md:grid-cols-robot-funds-md hover:bg-blueHover dark:hover:bg-blueHoverDark items-center"
              key={fund.isin}
            >
              {fund.type ? (
                <div className={`flex rounded-xl my-1.5 mr-2 truncate justify-center ${GetFundColorClass(fund.type)}`}>
                  <Typography className="truncate">{fund.type}</Typography>
                </div>
              ) : (
                <div className="mr-1"></div>
              )}

              <div className="flex w-full truncate">
                <Typography className="truncate">{fund.name} </Typography>
              </div>
              <div className="hidden justify-end md:flex">
                <Typography>
                  <GlobeComponent numGlobes={fund.morningstarSustainabilityRating} />
                </Typography>
              </div>
              <div className="hidden justify-end md:flex">
                <Typography>{fund.sfdrRating}</Typography>
              </div>
              <div className="flex justify-end">
                <Typography>{`${fund.percentage}%`}</Typography>
              </div>
              {ignoreFund(fund) ? (
                <div className="flex justify-end"></div>
              ) : (
                <div className="flex justify-end">
                  <Link target="_blank" href={morningstarKeyInfoLink(fund.isin)} prefetch={false}>
                    <Icon name={"paperClipIcon"} size="xxsmall" />
                  </Link>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};
